"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.Container = exports.Border = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3;

var Border = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-top: solid 2px ", ";\n  bottom: 2px;\n  color: ", ";\n  font-weight: ", ";\n  left: ", "%;\n  position: relative;\n  transition: left .25s;\n  width: ", "%;\n"])), _palette.palette.green, _palette.palette.green, _widths.font.semi, function (props) {
  return props.activeIndex * 100 / props.tabs;
}, function (props) {
  return 100 / props.tabs;
});

exports.Border = Border;
Border.displayName = 'Border';

var Container = _styledComponents["default"].ul(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var Tab = _styledComponents["default"].li(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  border-bottom: solid 1px ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  flex: 1;\n  font-size: 12px;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n\n  ", "\n"])), _palette.palette.lightGrey, _palette.palette.bobBlack, function (props) {
  return props.active && "\n    color: ".concat(_palette.palette.green, ";\n    font-weight: ").concat(_widths.font.semi, ";\n  ");
});

exports.Tab = Tab;
Tab.displayName = 'Tab';